import React, { useState } from "react";
import { Link } from "react-scroll";

//Assets
import navLogo from "../../Assets/logo.svg";
import youtube from "../../Assets/whiteYoutube.svg";
import inlogo from "../../Assets/whiteLinkedIn.svg";
import insta from "../../Assets/whiteInsta.svg";
import fb from "../../Assets/whiteFB.svg";

function NavBar() {
  const [navbar, setnavbar] = useState(false);

  const sidebar = () => {
    return (
      <div className="sidebar" menu={navbar ? 1 : 0}>
        <div className="sidebar_links">
          <div>
            <Link to="productsSection" smooth={true} duration={1000}>
              Products
            </Link>
          </div>
          <div>
            <Link to="servicesSection" smooth={true} duration={1000}>
              services
            </Link>
          </div>
          <div>
            <Link to="aboutUsSection" smooth={true} duration={1000}>
              About us
            </Link>
          </div>
          <div>
            <Link to="contactUsSection" smooth={true} duration={1000}>
              contact us
            </Link>
          </div>
        </div>
        <div className="socialinks">
          <div>
            <img src={youtube} alt="3D Model" />
          </div>
          <div>
            <img src={fb} alt="3D Model" />
          </div>
          <div>
            <img src={insta} alt="3D Model" />
          </div>
          <div>
            <img src={inlogo} alt="3D Model" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="navbar">
      <div className="navbar_logo">
        <Link to="homeSection" smooth={true} duration={1000}>
          <img src={navLogo} alt="stark Industries Logo" />
        </Link>
      </div>
      <div className="navbar_links">
        <div>
          <Link to="productsSection" smooth={true} duration={1000}>
            Products
          </Link>
        </div>
        <div>
          <Link to="servicesSection" smooth={true} duration={1000}>
            services
          </Link>
        </div>
        <div>
          <Link to="aboutUsSection" smooth={true} duration={1000}>
            About us
          </Link>
        </div>
        <div>
          <Link to="contactUsSection" smooth={true} duration={1000}>
            contact us
          </Link>
        </div>
      </div>
      <div
        className="navbar_menulogo"
        onClick={() => {
          setnavbar(!navbar);
        }}
        menu={navbar ? 1 : 0}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
      {sidebar()}
    </div>
  );
}

export default NavBar;
